// extracted by mini-css-extract-plugin
export default {"link":"uM-z","disabled":"vM-z"};